import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  @Input('showLoader') showLoader: boolean = false;
  @Input() inlineLoader: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
